import { useState } from "react";
import { Collapse, Spin } from "antd";
import { Checkbox } from "@components/Checkbox";
import { Button } from "@components/Button";
import cs from "./AdditionalProcessings.module.scss";

const { Panel } = Collapse;

export const Plastic = ({ machinelessServices, onChange, onSave }) => {
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Collapse
      defaultActiveKey={["PLASTIC"]}
      className={`ProcessingType ${cs.panel}`}
      expandIconPosition="right"
    >
      <Panel header="Obróbka dodatkowa tworzyw" key="METAL">
        <div className={cs.checkboxContainer}>
          <Checkbox
            label="Wiercenie otworów w tworzywach"
            style={{ fontSize: "18px" }}
            checked={machinelessServices.includes(129)}
            onChange={(e) => onChange(129, e.target.checked)}
          />

          <Checkbox
            label="Pogłębianie stożkowe otworów w tworzywach"
            style={{ fontSize: "18px" }}
            checked={machinelessServices.includes(131)}
            onChange={(e) => onChange(131, e.target.checked)}
          />

          <Checkbox
            label="Pogłębianie walcowe otworów w tworzywach"
            style={{ fontSize: "18px" }}
            checked={machinelessServices.includes(132)}
            onChange={(e) => onChange(132, e.target.checked)}
          />

          <div className="mt4 ml-auto">
            <Spin spinning={isLoading}>
              <Button type="primary" size="small" onClick={handleSave}>
                Zapisz zmiany
              </Button>
            </Spin>
          </div>
        </div>
      </Panel>
    </Collapse>
  );

  function handleSave() {
    setIsLoading(true);

    onSave();

    setTimeout(() => {
      setIsLoading(false);
    }, 300);
  }
};
